import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NacoService } from '../domains/services/naco.service';
import { fromPromise } from 'rxjs/internal/observable/fromPromise';
import { Signature } from '../domains/values/signature';
import { catchError, switchMap } from 'rxjs/internal/operators';
import { ErrorObservable } from 'rxjs-compat/observable/ErrorObservable';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    public constructor(private naco: NacoService) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return fromPromise(this.naco.getSignature()).pipe(
            switchMap((signature: Signature | null) => {
                if (!signature) {
                    return next.handle(req);
                }

                return next
                    .handle(
                        req.clone({
                            setHeaders: {
                                Authorization: `${signature.type} ${signature.token}`,
                            },
                        }),
                    )
                    .pipe(
                        catchError((error: HttpErrorResponse) => {
                            if (error.status === 401) {
                                return this.naco.refreshUser().pipe(
                                    switchMap((user: any) => {
                                        if (user) {
                                            return fromPromise(this.naco.getSignature()).pipe(
                                                switchMap((newSignature: Signature) => {
                                                    return next.handle(
                                                        req.clone({
                                                            setHeaders: {
                                                                Authorization: `${newSignature.type} ${newSignature.token}`,
                                                            },
                                                        }),
                                                    );
                                                }),
                                            );
                                        }

                                        return ErrorObservable.create(error);
                                    }),
                                );
                            }

                            return ErrorObservable.create(error);
                        }),
                    );
            }),
        );
    }
}
